import { render, staticRenderFns } from "./specialTranslation.vue?vue&type=template&id=14ee175a&scoped=true&"
import script from "./specialTranslation.vue?vue&type=script&lang=js&"
export * from "./specialTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ee175a",
  null
  
)

export default component.exports